export const percentFromRate = (rate = 0): string =>
  `${Math.round(rate * 100)}%`
